module.exports = __webpack_public_path__ + "img/Sarana Global Finance Indonesia.d66a5a6f.png";